import { Helmet } from 'react-helmet';
import { useVendorConfig } from 'store/vendor/useVendorConfig';
import { isLocalHost } from 'utils/isLocalHost';

export const DocumentMetas = () => {
  const { pageTitle, cookieBotID } = useVendorConfig();
  return (
    <Helmet>
      <meta name="description" content={pageTitle} />
      <title>{pageTitle}</title>

      {/* <!-- Cookiebot --> */}
      {cookieBotID && !isLocalHost && (
        <script
          id="Cookiebot"
          src="https://consent.cookiebot.com/uc.js"
          data-cbid={cookieBotID}
          data-blockingmode="auto"
          type="text/javascript"
        />
      )}
    </Helmet>
  );
};
